module.exports = __webpack_public_path__ + "img/typeedit.b288bf58.svg";